import { IUrlInformation } from "api/interfaces/get-page-details/common/nested-pagecontent.type";
import { IMakeActualResponse, IMakePageContent } from "api/interfaces/get-page-details/make-page.type";
import { MAKE_MODEL_YEAR, MAKE_YEAR_MODEL } from "component/vehicle-form/constants";
import { RootState } from "interfaces/generics.type";
import PageContainer from "modules/components/PageContainer";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { openModal } from "../../action/modal/openModal";
import usePrevious from "../../hoc/usePrevious";
import { getFragmentParams } from "../../util/url/getFragmentParams";
import { equalVehicles } from "../../util/vehicle/equal-vehicles";
import DynamicOrderComponents from "./DynamicOrderComponents";
import MetaHead from "./common/MetaHead";
import PageHeader from "./common/PageHeader";

interface IProps{
  urlInformation: IUrlInformation;
  staticContent: IMakePageContent;
  actualResponse: IMakeActualResponse;
}

function MakePage(props: IProps) {
  const {
    actualResponse, urlInformation, staticContent,
  } = props;

  const {
    pageDetails, pageStructure, links, relatedProducts,
  } = staticContent;
  const { modelsWithUrl, breadCrumbsV2 } = actualResponse;
  const { displayableMake } = pageDetails;
  const { make } = urlInformation;

  const router = useRouter();
  const selectedVehicle = useSelector((state: RootState) => state.garage.selectedVehicle);
  const prevSelectedVehicle = usePrevious(selectedVehicle);
  const { pathname } = router.query;

  const dispatch = useDispatch();
  const { t } = useTranslation("common");

  const vehicle = { make };
  const { popularMakeModelCategories, popularMakeCategories } = links || {};
  const modelData = modelsWithUrl;

  useEffect(() => {
    if (displayableMake) {
      const { model: fragmentModel } = getFragmentParams();
      dispatch(openModal("vehicleSelector", {
        title: `${t("Select model for")} ${displayableMake || make}`,
        // years,
        defaultMake: make,
        defaultModel: fragmentModel,
        selectionOrder: fragmentModel ? MAKE_MODEL_YEAR : MAKE_YEAR_MODEL,
      }));
    }
  }, []);

  useEffect(() => {
    if (!equalVehicles(prevSelectedVehicle, selectedVehicle)) {
      // user have selected new vehicle
      router.push("/#regular-service");
    }
  }, [selectedVehicle]);

  let pageContainer;
  if (pageStructure && pageStructure.length) {
    pageContainer = (
      <DynamicOrderComponents
        {...{ pageStructure }}
        {...{
          modelData,
          make,
          popularMakeCategories,
          popularMakeModelCategories,
          relatedProducts,
          displayableMake,
        }}
      />
    );
  }

  return (
    <PageContainer fullWidth>

      <MetaHead {...{
        ...staticContent.metaData, ...staticContent.pageDetails, pathname, bannerImages: staticContent.bannerImages,
      }}
      />

      <PageHeader {...{
        vehicle,
        pageDetails,
        bannerImages: staticContent.bannerImages,
        staticContent,
        breadCrumbsV2,
      }}
      />
      {pageContainer}
    </PageContainer>
  );
}

export default MakePage;
